export default (root: string) => ({
    projectGroup: (projectGroupId: string) => {
        const specificRoot = `${root}/projectGroups/${projectGroupId}`;
        return {
            root: specificRoot,
        };
    },
});
